import { createElement, Fragment } from 'react';

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function paramsToObject(entries) {
  var result = {};
  for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
      key = _step$value[0],
      value = _step$value[1];
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

var GTM_ID = "GTM-MVBT6T8";
var GTMScriptHead = function GTMScriptHead(_ref) {
  var _ref$gtm_id = _ref.gtm_id,
    gtm_id = _ref$gtm_id === void 0 ? GTM_ID : _ref$gtm_id;
  return (
    // eslint-disable-next-line @next/next/next-script-for-ga
    createElement("script", {
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','" + gtm_id + "');"
      }
    })
  );
};
var GTMScriptBody = function GTMScriptBody(_ref2) {
  var _ref2$gtm_id = _ref2.gtm_id,
    gtm_id = _ref2$gtm_id === void 0 ? GTM_ID : _ref2$gtm_id;
  return createElement("noscript", null, createElement("iframe", {
    src: "https://www.googletagmanager.com/ns.html?id=" + gtm_id,
    height: "0",
    width: "0",
    style: {
      display: "none",
      visibility: "hidden"
    }
  }));
};
var RudderStackScript = function RudderStackScript() {
  var host = "https://universe.staderlabs.com";
  var rsMinJs = host + "/rs-cdn/v1.1/rudder-analytics.min.js";
  var dataPlane = host + "/l-p/rs-dataplane";
  var configUrl = host + "/rudderlabs/sourceConfig";
  return createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: "!function(){var e=window.rudderanalytics=window.rudderanalytics||[];e.methods=[\"load\",\"page\",\"track\",\"identify\",\"alias\",\"group\",\"ready\",\"reset\",\"getAnonymousId\",\"setAnonymousId\",\"getUserId\",\"getUserTraits\",\"getGroupId\",\"getGroupTraits\"],e.factory=function(t){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(t),e.push(r),e}};for(var t=0;t<e.methods.length;t++){var r=e.methods[t];e[r]=e.factory(r)}e.loadJS=function(e,t){var r=document.createElement(\"script\");r.type=\"text/javascript\",r.async=!0,r.src=\"" + rsMinJs + "\";var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(r,a)},e.loadJS(),\n          e.load(\"2E0kslmrvgrH84NmPoKKsFKwhP5\",\"" + dataPlane + "\", {configUrl: \"" + configUrl + "\"}),\n          e.page()}();"
    }
  });
};
var DefaultScripts = function DefaultScripts() {
  return createElement(Fragment, null, createElement(RudderStackScript, null));
};
var UTM_PARAMS = {
  utm_referral: 1,
  utm_source: 1,
  utm_medium: 1,
  utm_campaign: 1,
  utm_term: 1,
  utm_content: 1
};
var getRefrenceParams = function getRefrenceParams() {
  var _window = window,
    location = _window.location;
  // removed use of useRouter as there was delay in fetching url parameters
  // reading params from window.location instead.
  try {
    var params = new URLSearchParams(location.search);
    var query = paramsToObject(params);
    var x = {};
    for (var key in UTM_PARAMS) {
      if (query[key]) {
        x[key] = query[key];
      }
    }
    return x;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("useRefrenceParams error", e);
    return {};
  }
};

export { DefaultScripts, GTMScriptBody, GTMScriptHead, RudderStackScript, getRefrenceParams };
//# sourceMappingURL=app-head.esm.js.map
